import * as $ from 'jquery';
import { default as debounce } from "lodash-es/debounce";
import { onLoad, onMouseEnter, onMouseLeave } from 'Core/Events';



/**
 * @description Komponent górnej nawigacji Bodzia na którym się znajdują strony statyczne oraz przyciski
 * do panelu mojego konta, koszyka, kalkulacji, szukajki oraz ulubionych. Funkcje tego komponentu
 * dotyczą głównie obsługi mobile dlatego, ze tylko tam Navbar ma swoja customową logikę
 * wyświetlania. Na Desktopach wszystkim się zajmuje Bootstrap
 */

export const Navbar = (() => {

	const Selector = {
		MEGAMENU_ACTIVATOR_BTN: '.main-header .megamenu-holder',
		MEGAMENU: '.main-header .megamenu',
		HEADER_BOTTOM: '.main-header .header-b',
		MEGAMENU_CATEGORY_ITEMS: '.main-header .megamenu-category',
		HEADER_ITEM_NO_MEGAMENU: '.main-header .no-mega-menu',
		HEADER_COLLAPSIBLE: '#header-collapsible',
		HEADER_ROW_1: '#header-row-1',
		HEADER_ROW_2: '#header-row-2',
		INFOBAR: '#info-bar',
		SEARCH_CONTAINER: '.search_container',
		SEARCH_INPUT: '.search_container input'
	};

	//create debounce to set timeout on invoke megamenu
	const debouncedFunction = debounce(openMegamenu, 300);


	onMouseEnter(Selector.MEGAMENU_ACTIVATOR_BTN, debouncedFunction)
	onMouseLeave(Selector.HEADER_BOTTOM, hideMegamenu)
	onMouseEnter(Selector.HEADER_ITEM_NO_MEGAMENU, hideMegamenu)

	onLoad(() => {
		initMobileHeaderScroll();
		initSearchActiveState();
	});

	function initMobileHeaderScroll() {
		// Scroll behavior is handled by CSS - .header-t-mobile is sticky
		// .main-header and .header-collapsible scroll naturally
	}

	function initSearchActiveState() {
		if (window.location.pathname.includes('/search')) {
			$(Selector.SEARCH_CONTAINER).addClass('search_container--active');
		}
	}

	function openMegamenu() {
		const currentCat = $(this).attr('id');
		const megamenu_target = $(Selector.MEGAMENU).find(`[data-content='${currentCat}']`);
		const currentMegamenuMinWidth = calcDistanceToWindowLeft($(this)); //minimum width of megamenu based on position of element which init megamenu
		const currentMegamenuWidth = calcWidthBasedOnItems(megamenu_target); //width of megamenu based on elements inside megamenu

		$(Selector.MEGAMENU_CATEGORY_ITEMS).removeClass('d-flex');

		prepareMegamenu($(Selector.MEGAMENU), megamenu_target, currentMegamenuMinWidth, currentMegamenuWidth);
	}

	function hideMegamenu() {
		debouncedFunction.cancel(); //cancel debounce if the cursor moves out from the injector button
		$(Selector.MEGAMENU).hide();
		$(Selector.MEGAMENU_CATEGORY_ITEMS).removeClass('d-flex');
	}

	function calcDistanceToWindowLeft(target) { //minimum width of dropdown based on current menu dropdown injector (Meble, Pomieszczenia, Akcesoria)
		const offset = $(target).offset();
		let finalMinWidth = $(target).outerWidth() + offset?.left;
		return finalMinWidth;
	}

	function calcWidthBasedOnItems(target) {
		const targetColumn = $(target).find('>div');
		const item_qty = targetColumn.children().length; //categories inside megamenu
		const item_height = 40; //basic line height
		const items_height = item_qty * item_height; //summary items height before divide by columns
		const column_width = targetColumn.outerWidth(true); //categories column width

		const columns_qty = Math.ceil(items_height / targetColumn.height()); //qty of columns based on categories count 

		let finalWidth = column_width * columns_qty; //final width without blue area

		if ($(target).find('.megamenu-blue-area').length > 0) { //blue place for some product on first megamenu
			finalWidth += $(target).find('.megamenu-blue-area').width();
		}

		return finalWidth;

	}

	function prepareMegamenu(megamenu, element, minWidth, width) {
		$(megamenu).css({ 'min-width': `${minWidth}px`, 'width': `${width}px` }); //minimum width and width of megamenu
		$(element).addClass('d-flex');
		$(megamenu).slideDown(350);
	}

})();
import * as $ from 'jquery';
import { default as debounce } from "lodash-es/debounce";
import { onLoad, onMouseEnter, onMouseLeave } from 'Core/Events';



/**
 * @description Komponent górnej nawigacji Bodzia na którym się znajdują strony statyczne oraz przyciski
 * do panelu mojego konta, koszyka, kalkulacji, szukajki oraz ulubionych. Funkcje tego komponentu
 * dotyczą głównie obsługi mobile dlatego, ze tylko tam Navbar ma swoja customową logikę
 * wyświetlania. Na Desktopach wszystkim się zajmuje Bootstrap
 */

export const Navbar = (() => {

	const Selector = {
		MEGAMENU_ACTIVATOR_BTN: '.main-header .megamenu-holder',
		MEGAMENU: '.main-header .megamenu',
		HEADER_BOTTOM: '.main-header .header-b',
		MEGAMENU_CATEGORY_ITEMS: '.main-header .megamenu-category',
		HEADER_ITEM_NO_MEGAMENU: '.main-header .no-mega-menu',
		HEADER_COLLAPSIBLE: '#header-collapsible',
		HEADER_ROW_1: '#header-row-1',
		HEADER_ROW_2: '#header-row-2',
		INFOBAR: '#info-bar',
		SEARCH_CONTAINER: '.search_container',
		SEARCH_INPUT: '.search_container input'
	};

	//create debounce to set timeout on invoke megamenu
	const debouncedFunction = debounce(openMegamenu, 300);


	onMouseEnter(Selector.MEGAMENU_ACTIVATOR_BTN, debouncedFunction)
	onMouseLeave(Selector.HEADER_BOTTOM, hideMegamenu)
	onMouseEnter(Selector.HEADER_ITEM_NO_MEGAMENU, hideMegamenu)

	onLoad(() => {
		initMobileHeaderScroll();
		initSearchActiveState();
	});

	function initMobileHeaderScroll() {
		// Scroll behavior is handled by CSS - .header-t-mobile is sticky
		// .main-header and .header-collapsible scroll naturally
	}

	function initSearchActiveState() {
		if (window.location.pathname.includes('/search')) {
			$(Selector.SEARCH_CONTAINER).addClass('search_container--active');
		}
	}

	function openMegamenu() {
		const currentCat = $(this).attr('id');
		const megamenu_target = $(Selector.MEGAMENU).find(`[data-content='${currentCat}']`);
		const currentMegamenuMinWidth = calcDistanceToWindowLeft($(this)); //minimum width of megamenu based on position of element which init megamenu
		const currentMegamenuWidth = calcWidthBasedOnItems(megamenu_target); //width of megamenu based on elements inside megamenu

		$(Selector.MEGAMENU_CATEGORY_ITEMS).removeClass('d-flex');

		prepareMegamenu($(Selector.MEGAMENU), megamenu_target, currentMegamenuMinWidth, currentMegamenuWidth);
	}

	function hideMegamenu() {
		debouncedFunction.cancel(); //cancel debounce if the cursor moves out from the injector button
		$(Selector.MEGAMENU).hide();
		$(Selector.MEGAMENU_CATEGORY_ITEMS).removeClass('d-flex');
	}

	function calcDistanceToWindowLeft(target) { //minimum width of dropdown based on current menu dropdown injector (Meble, Pomieszczenia, Akcesoria)
		const offset = $(target).offset();
		let finalMinWidth = $(target).outerWidth() + offset?.left;
		return finalMinWidth;
	}

	function calcWidthBasedOnItems(target) {
		const targetColumn = $(target).find('>div');
		const item_qty = targetColumn.children().length; //categories inside megamenu
		const item_height = 40; //basic line height
		const items_height = item_qty * item_height; //summary items height before divide by columns
		const column_width = targetColumn.outerWidth(true); //categories column width

		const columns_qty = Math.ceil(items_height / targetColumn.height()); //qty of columns based on categories count 

		let finalWidth = column_width * columns_qty; //final width without blue area

		if ($(target).find('.megamenu-blue-area').length > 0) { //blue place for some product on first megamenu
			finalWidth += $(target).find('.megamenu-blue-area').width();
		}

		return finalWidth;

	}

	function prepareMegamenu(megamenu, element, minWidth, width) {
		$(megamenu).css({ 'min-width': `${minWidth}px`, 'width': `${width}px` }); //minimum width and width of megamenu
		$(element).addClass('d-flex');
		$(megamenu).slideDown(350);
	}

})();
